import type { IAuthAccountMenuItem } from '@/entities/auth-account.d';

import { toAuditRoutePath } from './menu';

export type PersonalMenuAction = 'logout' | 'navigate' | 'none' | 'switchTenant';

export const PERSONAL_MENU_ACTION_PATHS = {
  logout: '_action:logout',
  switchTenant: '_action:switch-tenant',
} as const;

/** normalizePersonalMenus 过滤禁用个人菜单，并只规整审核中心已经确认的历史路径。 */
export function normalizePersonalMenus(items: IAuthAccountMenuItem[] = []) {
  return [...items]
    .filter(item => !item.disabled && Boolean(item.path || item.titleLocal || item.title))
    .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0))
    .map(item => ({
      ...item,
      // 账号安全拥有独立页面，审核兼容规则不能再吞掉 /workspace/account。
      path: toAuditRoutePath(item.path) || item.path,
    }));
}

/** isPersonalMenuRemotePage 判断个人菜单是否单独授权了当前审核 remote 路径。 */
export function isPersonalMenuRemotePage(items: IAuthAccountMenuItem[], pathname: string) {
  return pathname === '/workspace/audit'
    && items.some(item => item.path === pathname);
}

/** 个人中心菜单的 action 路径由后端权限配置决定，其他路径统一交给租户内路由。 */
export function resolvePersonalMenuAction(item?: IAuthAccountMenuItem): PersonalMenuAction {
  if (!item?.path) return 'none';
  if (item.path === PERSONAL_MENU_ACTION_PATHS.logout) return 'logout';
  if (item.path === PERSONAL_MENU_ACTION_PATHS.switchTenant) return 'switchTenant';
  return 'navigate';
}

/** getPersonalMenuTitle 为个人菜单生成本地化优先的可见标题。 */
export function getPersonalMenuTitle(item: IAuthAccountMenuItem) {
  return item.titleLocal || item.title || item.path;
}
